import React, { Component } from "react";

import { ContentSection, ContentBlock } from "../components";
import { CampaignListContainer } from "../../campaign/components";

import { Localize } from "../../../locale/localization";

class CampaignAdminPage extends Component {
  render() {
    return (
      <ContentSection>
        <ContentBlock title={Localize("campaign-time")}>
          <CampaignListContainer />
        </ContentBlock>
      </ContentSection>
    );
  }
}

export default CampaignAdminPage;



// WEBPACK FOOTER //
// ./src/modules/pages/admin/CampaignAdminPage.js